<template>
  <div 
    :class="['stats-chart', css]"
  >
    <div 
      v-if="title"
      class="chart-header"
    >
      <h3 class="chart-title">{{ title }}</h3>
      <div class="chart-legend"></div>
    </div>
    <div class="chart-content">
      <div 
        :class="['row-chart', {'bar-count': includeCounts}]"
        :style="[{'width': graphWidth}]"
      >
        <div 
          v-for="(stat, index) in stats"
          :key="index"
          class="bar" 
          :style="[{'--count': stat.count}, {'--bar-width': stat.width}, {'min-width': this.barsMinWidth}, {'--bar-color': stat.color}]"
          :ref="'bar-' + index"
        >
          <span v-if="includeCounts">{{ stat.count }}</span>
        </div>
        <div
          v-if="includeTotal"
          class="chart-total"
        >{{ total }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },

  props: {
    title: String,
    data: Array,
    css: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    barsWidth: String,
    barsMinWidth: String,
    includeCounts: Boolean,
    includeTotal: Boolean,
    showTooltips: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      stats: [],
      total: null
    }
  },

  watch: {
    data: {
      handler(newValue, oldValue) {
        this.setData()
      }, 
      immediate: true,
      deep: true
    }
  },

  mounted: function() {
    if (this.showTooltips) {
      const vm = this;
      
      this.stats.forEach((stat, index) => {
        const bar = this.$refs['bar-' + index];

        const t = new bootstrap.Tooltip(bar[0], {
          title: stat.title,
          html: true,
          placement: 'top',
          trigger : 'hover'
        })
      })
    }
  },

  computed: {
    graphWidth: function() {
      return this.barsWidth ? '' : this.width;
    }
  },

  methods: {
    setData: function() {
      this.total = this.data.length > 0 ? this.data[0][4] : null;

      this.stats = this.data.map((s) => {
        const p = Math.round(s[1] * 10) / 10;

        return {
          color: s[3],
          count: s[0],
          title: s[2], 
          percentage: p,
          width: this.barsWidth || p + '%',
        }
      })
    }
  }
}

</script>